/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthOutputs } from '../../auth/services/auth-outputs.service';
import { RallyAuthOutputs } from '../rally-auth-outputs.service';
import { ActivatedRoute } from '@angular/router';

import { Tenant } from '@touchplan/common';

@Component({
	selector: 'rally',
	templateUrl: './rally.component.html',
	styleUrls: ['./rally.component.scss'],
	providers: [{ provide: AuthOutputs, useClass: RallyAuthOutputs }],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RallyComponent implements OnInit {
	constructor(protected authOutputs: AuthOutputs, private activatedRoute: ActivatedRoute) {}

	// BEGIN PLACEHOLDER REPLACE AS PART OF TP-5570
	public tempCompleteLogin() {
		this.authOutputs.finishLogin(Tenant.getDefaultTenant(), this.activatedRoute);
	}
	// END PLACEHOLDER REPLACE AS PART OF TP-5570

	public ngOnInit() {
		console.log('blah');
	}
}
